import 'bootstrap';
import ready, { HTML } from "./utils";
import initAOS from "./components/aos";
import initMobileNav from "./components/mobileNav";
import initSwitchImage from "./components/switchImage";
import initNotes from "./components/notes";
import initBlockPositions from "./components/blockPositions";
import initFitty from "./components/fitty";

ready(() => {
    HTML.classList.add('is-loaded');
    initAOS();
    initMobileNav();
    initSwitchImage();
    initNotes();
    initBlockPositions();
    initFitty();
});
